import { render, staticRenderFns } from "./explanation-of-payment-overlay.component.vue?vue&type=template&id=62925195&"
import script from "./explanation-of-payment-overlay.component.vue?vue&type=script&lang=ts&"
export * from "./explanation-of-payment-overlay.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports